module.exports = __webpack_public_path__ + "static/media/gcdef_10005.9388a13f.ico";